import { render } from "./CustomSelection.vue?vue&type=template&id=3e9ba13c"
import script from "./CustomSelection.vue?vue&type=script&lang=js"
export * from "./CustomSelection.vue?vue&type=script&lang=js"

import "./CustomSelection.vue?vue&type=style&index=0&id=3e9ba13c&lang=css"
script.render = render

export default script